import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import MarqueeStrip from "@/components/landing/Marquee";
import Parties from "@/components/landing/Parties";
import Clubs from "@/components/landing/Clubs";
import Manifesto from "@/components/landing/Manifesto";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div id="top" className="min-h-screen bg-coal font-manrope text-white">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <MarqueeStrip />
          <Parties />
          <Clubs />
          <Manifesto />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
